import styled from 'styled-components';

export const UpperBar = styled.div`
  font-size: 20px;
  color: white;

  width: 100%;
  height: 60px;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  background-color: #313131;
  z-index: 1;
  @media only screen and (max-device-width: 800px) {
      width: 100%;
      height: 40px;
      font-size: 14px;
  }
`;


export const LinkBar = styled.a`
  text-decoration: none; 
  margin-right: 2%; 
  margin-left: 2%; 
  * {
    color: white;
    &:hover, 
    &:focus{ 
      color: #F26E0E;}
    text-decoration: none !important;
    }
    
`;

export const Container = styled.div`
  @media only screen and (max-device-width: 800px) {
      width: 100%;
  }
`
